type CampaignCollectingFields =
    | {
          firstScrapeTime?: string | null;
      }
    | null
    | undefined;

export const isCampaignCollecting = (campaign: CampaignCollectingFields): boolean =>
    !!campaign && !campaign.firstScrapeTime;
